import { type ReactNode, createElement } from 'react';
import { Trans, useTranslation as useI18nextTranslation } from 'react-i18next';

export { Trans };

const TRANSLATION_MODE_KEY = 'allo:translation-mode';

export const isTranslationMode: boolean = (() => {
  try {
    return localStorage.getItem(TRANSLATION_MODE_KEY) === 'true';
  } catch {
    return false;
  }
})();

if (isTranslationMode && typeof document !== 'undefined') {
  document.body.classList.add('translation-mode');
}

export const useTranslation = (ns?: any, options?: any) => {
  const result = useI18nextTranslation(ns, options);
  const { t: originalT } = result;

  if (!isTranslationMode) {
    return { ...result, tRaw: originalT };
  }

  const t = (key: string, opts?: Record<string, unknown>): ReactNode => {
    const text = originalT(key as any, opts as any);
    const effectiveNs = (opts?.ns as string) ?? ns ?? 'desktop_common';
    const fullKey = `${effectiveNs}:${options?.keyPrefix ? `${options.keyPrefix}.` : ''}${key}`;
    return createElement('span', { 'data-i18n-key': fullKey }, text);
  };

  return { ...result, t: t as typeof originalT, tRaw: originalT };
};
